'use client';
import React from 'react';
import { useState, useEffect } from 'react';
import styles from './LoadingPage.module.scss';

const BeatLoader = ({
    color = '#00B45E',
    size = 15,
    margin = 2,
    speed = 1.4
}) => {
    const dotStyle = {
        backgroundColor: color,
        width: `${size}px`,
        height: `${size}px`,
        margin: `0 ${margin}px`,
        animationDuration: `${speed}s`
    };

    return (
        <div className={styles.loaderContainer}>
            <style>{`
        .${styles.dot} {
          animation-duration: ${speed}s;
        }
        .${styles.dot1} {
          animation-delay: ${speed * 0.1}s;
        }
        .${styles.dot2} {
          animation-delay: ${speed * 0.2}s;
        }
      `}</style>

            <div className={styles.dot} style={dotStyle} />
            <div className={`${styles.dot} ${styles.dot1}`} style={dotStyle} />
            <div className={`${styles.dot} ${styles.dot2}`} style={dotStyle} />
        </div>
    );
};

const LoadingPage = () => {

    const [isLoading, setIsLoading] = useState(true); // Добавляем состояние загрузки

    useEffect(() => {
        setIsLoading(false); // Когда компонент загрузился, убираем индикатор загрузки
    }, []);

    return (
        <>
            {
                isLoading ?
                    <div className={styles.loadingPage} >
                        {/* Можно добавить логотип или анимацию загрузки */}
                        < BeatLoader size={20} speed={1.2} />
                    </div >
                    :
                    null
            }
        </>
    );
};

export default LoadingPage;